export enum ShopCountry {
  BE = 'BE',
  DE = 'DE',
  FR = 'FR',
  GB = 'GB',
  NL = 'NL'
}

export class ShopID {
  private static shopIDRegex = /^[A-Z]{2}[0-9]{6}$/

  static from(id: string): ShopID | null {
    if (ShopID.shopIDRegex.test(id)) {
      return new ShopID(id)
    }

    return null
  }

  private constructor(private id: string) {}

  get country(): ShopCountry {
    return this.id.slice(0, 2) as ShopCountry
  }
}
